import React, {useState} from 'react';
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import {ConfigProvider, Input, List, Spin} from "antd";
import {findCountryCode} from '../components/CountrySelect';
import { isCountryUk } from '../util/gearOrderUtil';

/**
 * The Google patient shipping address form.
 *
 * @param props.onChangeHandlers An object containing the onChange functions for each field.
 */
const GoogleAddressInputForm = props => {
  let countryRestrictions = !props.isInternational ? { country: "US" } : {};

  if (props.form.country.value) {
    let countryCode = findCountryCode(props.form.country.value);
    if (countryCode !== undefined) {
      countryRestrictions = { country: countryCode };
    }
  }

  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    apiKey: process.env.REACT_APP_GOOGLE_PLACES_KEY,
    options: {
      types: ["address"],
      componentRestrictions: countryRestrictions, // This component restriction must be made dynamic if we start to push international users to gear.
    },
  });

  const [focused, setFocused] = useState(false);

  const setAddressComponents = (addressComponents) => {
    let address = {
      city: '',
      state: '',
      address1: '',
      address2: '',
      zipCode: '',
      country: '',
      county: ''
    }
    let streetNumber = '';
    let route = '';

    // Extract country from addressComponents
    const countryComponent = addressComponents.find(component => component.types?.includes('country'));
    if (countryComponent) {
      address.country = countryComponent.long_name;
    }
    /**
     * For uk addresses, Google uses 'postal_town' instead of 'locality' for the city.
     * Additionally, can extract county information from 'administrative_area_level_2' if available need to display for UK addresses.
     * e.g. 54 North St, England, Guildford, UK GU1 4AF
     * locality or postal_town = Guildford
     * administrative_area_level_1 = England
     * country = United Kingdom
     * postal_code = GU1 4AF
     */
    addressComponents.forEach((currentValue) => {
        if(isCountryUk(address.country) && currentValue.types?.includes('postal_town')) {
          address.city = currentValue.short_name;
        } else if (currentValue.types?.includes('locality')) {
          address.city = currentValue.short_name;
        }
        if (currentValue.types?.includes('administrative_area_level_1')) {
          address.state = currentValue.short_name;
        }
        if (currentValue.types?.includes('administrative_area_level_2')) {
          address.county = currentValue.short_name;
        }
        if (currentValue.types?.includes('postal_code')) {
          address.zipCode = currentValue.short_name;
        }
        if (currentValue.types?.includes('subpremise')) {
          address.address2 += currentValue.short_name;
        }
        if (currentValue.types?.includes('street_number')) {
          streetNumber = currentValue.short_name;
        }
        if (currentValue.types?.includes('route')) {
          route = currentValue.short_name;
        }
    });
    address.address1 = streetNumber + ' ' + route;
    address.address1.trim();

    props.onChangeHandlers.city(address['city']);
    props.onChangeHandlers.state(address['state']);
    props.onChangeHandlers.address1(address['address1']);
    props.onChangeHandlers.address2(address['address2']);
    props.onChangeHandlers.zipCode(address['zipCode']);
    props.onChangeHandlers.country(address['country']);
    props.onChangeHandlers.county(address['county']);
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: 'Open Sans, sans-serif',
          colorPrimary: '#275081',
        },
        components: {
          Input: {
            borderRadius: 0,
          },
        }
      }}
    >
      <div style={{paddingBottom: "0px", marginBottom: "0px"}}>
        <Spin spinning={isPlacePredictionsLoading} delay={600}>
          <Input.Search
            autoComplete="new-password"
            value={props.form.address1.value}
            onChange={(evt) => {
              getPlacePredictions({ input: evt.target.value, componentRestrictions: countryRestrictions });
              props.onChangeHandlers.address1(evt.target.value);
            }}
            onFocus={() => setFocused(current => !current)}
            onBlur={() => setTimeout(() => setFocused(current => !current), 200)} // Set with 200ms timeout to allow the onClick function to run before onBlur
            loading={isPlacePredictionsLoading}
          />
        </Spin>
          {(placePredictions?.length > 0 && focused) && (
            <div
              style={{
                display: "flex",
                position: "absolute",
                width: "100%",
                flex: "1",
                flexDirection: "column",
                zIndex: "9999"
              }}
            >
              <List
                style={{
                  backgroundColor: "white"
                }}
                size='small'
                bordered
                dataSource={placePredictions}
                renderItem={(item) =>
                  (<List.Item className="ant-list-button" onClick={() => {
                    placesService.getDetails({ placeId: item.place_id, fields: ["name", "address_components"]}, (place, status) => {
                      if (status === 'OK') {
                        setAddressComponents(place.address_components);
                      }
                    })
                  }
                  }>
                    <List.Item.Meta title={<button type="button" style={{ color: 'inherit' }} className="btn btn-link btn-unstyled"><strong>{item.description}</strong></button>} />
                  </List.Item>)
                }
              />
            </div>
          )}
        </div>
    </ConfigProvider>
  )
}
export default GoogleAddressInputForm;